import React, { useState } from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import styled, { css } from 'styled-components';
import {
  brandColours,
  fontSize,
  maxBreakpointQuery,
  minBreakpointQuery,
  standardColours,
  visuallyHidden,
  zIndexLayers,
} from '../styles';
import { Button, Container } from './ui';
import Logo from './Logo';
import Navigation from './Navigation';

const StyledHeader = styled.header`
  background-color: ${({ isBlogDetail, isCaseStudyDetail }) =>
    isBlogDetail || isCaseStudyDetail
      ? standardColours.white
      : brandColours.primary};
  position: relative;
  z-index: ${zIndexLayers.fourth};

  ${({ displayNav }) => {
    if (displayNav) {
      return css`
        ${maxBreakpointQuery.mlarge`
          position: fixed;
          width: 100%;
          height: 100%;
          top: 0;
        `}
      `;
    }
  }}
`;

const StyledInner = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${maxBreakpointQuery.mlarge`
    padding-top: 20px;
    padding-bottom: 20px;
  `}
`;

const StyledLogo = styled(Logo)`
  width: 160px;

  ${minBreakpointQuery.small`
    width: 170px;
  `}

  ${minBreakpointQuery.large`
    width: 180px;
  `}

  ${({ displayNav }) => {
    if (displayNav) {
      return css`
        ${maxBreakpointQuery.mlarge`
          z-index: ${zIndexLayers.fourth};
        `}
      `;
    }
  }}
`;

const StyledButton = styled(Button)`
  ${maxBreakpointQuery.mlarge`
    ${visuallyHidden()};
  `}

  ${minBreakpointQuery.mlarge`
    padding: 16px 32px;
    ${fontSize(14)};
  `}
`;

const Header = ({ isBlogDetail, isCaseStudyDetail }) => {
  const {
    datoCmsHeader: { link },
  } = useStaticQuery(graphql`
    query HeaderQuery {
      datoCmsHeader {
        link {
          text
          pageUrl {
            ...LinkFragment
          }
        }
      }
    }
  `);

  const [displayNav, setDisplayNav] = useState(false);

  return (
    <StyledHeader
      isBlogDetail={isBlogDetail}
      isCaseStudyDetail={isCaseStudyDetail}
      displayNav={displayNav}
    >
      <Container wider={true}>
        <StyledInner>
          <StyledLogo displayNav={displayNav} />
          <Navigation
            displayNav={displayNav}
            setDisplayNav={setDisplayNav}
            link={link}
          />
          <StyledButton to={link.pageUrl}>{link.text}</StyledButton>
        </StyledInner>
      </Container>
    </StyledHeader>
  );
};

export default Header;
